/**
 *
 * @module consoleSinkConfiguration
 *
 */

/**
 *
 * @class ConsoleSinkConfiguration
 * @desc A model containing the console sink configuration settings.
 *
 */
export default class ConsoleSinkConfiguration {

    /**
     *
     * @param {String} logLevel
     *
     */
    constructor(logLevel) {

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.logLevel = logLevel;

    }

}



// WEBPACK FOOTER //
// ./src/logging/consoleSinkConfiguration.js